import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

import { MarkdownEditorModule } from '../../../components/markdown-editor/markdown-editor.module';
import { BlockPreviewModule } from '../block-preview/block-preview.module';
import { ContentSectionsEditorModule } from '../content-sections-editor.module';
import { ContentSuburbWorkspaceComponent } from './content-suburb-workspace.component';
import { SuburbDataListComponent } from './list/suburb-data-list.component';
import { ContentSuburbComponent } from './page/content-suburb.component';
import { SuburbBlockEditorComponent } from './page/suburb-block-editor.component';
import { SuburbPageContentComponent } from './page/suburb-page-content.component';
import { SuburbPageSettingsComponent } from './page/suburb-page-settings.component';
import { SuburbColourPickerComponent } from './panel/suburb-colour-picker.component';
import { SuburbCouncilFillComponent } from './panel/suburb-council-fill.component';
import { SuburbDataTabComponent } from './panel/suburb-data-tab.component';
import { SuburbDraftsComponent } from './panel/suburb-drafts.component';
import { SuburbNotesComponent } from './panel/suburb-notes.component';
import { SuburbOtherPagesComponent } from './panel/suburb-other-pages.component';
import { SuburbOverviewComponent } from './panel/suburb-overview.component';
import { SuburbPlacesTabComponent } from './panel/suburb-places-tab.component';
import { SuburbRegionsPanelComponent } from './panel/suburb-regions-panel.component';
import { SuburbSidePanelComponent } from './panel/suburb-side-panel.component';
import { SuburbSubRegionPanelComponent } from './panel/suburb-subregion-panel.component';
import { SuburbCustomPlaceComponent } from './places/suburb-custom-place.component';
import { SuburbPendingComponent } from './places/suburb-pending.component';
import { SuburbPlacePopupComponent } from './places/suburb-place-popup.component';
import { SuburbPlaceComponent } from './places/suburb-place.component';
import { ReadinessCellComponent } from './readiness/readiness-cell.component';
import { ReadinessFiltersComponent } from './readiness/readiness-filters.component';
import { SuburbReadinessComponent } from './readiness/suburb-readiness.component';
import { PageOutlineComponent } from './template/page-outline.component';
import { PageTemplateEditorComponent } from './template/page-template-editor.component';
import { SuburbChecksComponent } from './tools/suburb-checks.component';
import { SuburbRegionTallyComponent } from './tools/suburb-region-tally.component';
import { SuburbRegionToolsComponent } from './tools/suburb-region-tools.component';
import { SuburbSearchComponent } from './tools/suburb-search.component';
import { SuburbToolsComponent } from './tools/suburb-tools.component';

/**
 * Suburbs (#256): the workspace popup and everything inside it. The region editor it hosts in its side panel
 * (ContentRegionComponent) belongs to ContentModule and is mounted by type, so it isn't imported here; the Page tab
 * (ContentSuburbComponent) and the page template editor (#262) are this tool's own. README.md in this folder maps the
 * parts.
 */
@NgModule({
  declarations: [
    // The shell, its tool column and its side panel.
    ContentSuburbWorkspaceComponent,
    SuburbToolsComponent,
    SuburbRegionToolsComponent,
    SuburbSearchComponent,
    SuburbRegionTallyComponent,
    SuburbChecksComponent,
    SuburbSidePanelComponent,
    // A suburb's tabs.
    SuburbOverviewComponent,
    SuburbPlacesTabComponent,
    SuburbDataTabComponent,
    SuburbNotesComponent,
    SuburbDraftsComponent,
    // The other panels.
    SuburbRegionsPanelComponent,
    SuburbSubRegionPanelComponent,
    SuburbCouncilFillComponent,
    SuburbColourPickerComponent,
    SuburbOtherPagesComponent,
    SuburbPlaceComponent,
    SuburbPlacePopupComponent,
    SuburbCustomPlaceComponent,
    SuburbPendingComponent,
    // The List view.
    SuburbDataListComponent,
    // The Readiness view (#262).
    SuburbReadinessComponent,
    ReadinessFiltersComponent,
    ReadinessCellComponent,
    // A suburb's Page tab and the page templates (#262).
    ContentSuburbComponent,
    SuburbPageSettingsComponent,
    SuburbPageContentComponent,
    SuburbBlockEditorComponent,
    PageOutlineComponent,
    PageTemplateEditorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    DialogModule,
    DropdownModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    MenuModule,
    MultiSelectModule,
    SelectButtonModule,
    TableModule,
    TooltipModule,
    MarkdownEditorModule,
    ContentSectionsEditorModule,
    BlockPreviewModule,
  ],
  exports: [ContentSuburbWorkspaceComponent],
})
export class SuburbsModule {}
